import { Component, Input } from '@angular/core';

@Component({
  selector: 'cab-configuration-formula-builder',
  templateUrl: './cab-configuration-formula-builder.component.html',
  styleUrls: ['./cab-configuration-formula-builder.component.scss'],
})
export class CustomAvailableBudgetConfigurationFormulaBuilderComponent {
  @Input() highlightAllOperands = false;
  @Input() selectedItems: string[] = [];
  @Input() nonHighlightedFormulaItem = ['Total Budget', 'Available Budget'];
  availableBudgetFormulaItems = this.nonHighlightedFormulaItem[1].split(' ');
  @Input() isOnBudgetPage = false;

  ngOnInit(): void {
  }

  isHighlightOperand(item: string): boolean {
    if(this.highlightAllOperands) {
      return true;
    }
    return !this.nonHighlightedFormulaItem.includes(item);
  }

  
}
